export const getDesignTokens = async (theme: string) => {
	const { default: getTokens } = await import(`../assets/theme/theme.${theme}`);

	return getTokens();
};
